module.exports = __webpack_public_path__ + "img/bingo_ball-66.94aea59f.png";